import { Pipe, PipeTransform } from '@angular/core';
import * as moment from 'moment-timezone';

// since it is using momentjs to parse format, refer to below page for documentation
// https://momentjs.com/docs/#/parsing/string-format/
@Pipe({
    name: 'timezone'
})
export class TimezonePipe implements PipeTransform {

    private default_timezone = 'US/Eastern';
    private default_format = 'MMM DD, YYYY';

    transform(value: any, format?: string, timezone?: string): string {
        if (!format) {
            format = this.default_format;
        }
        if (!timezone) {
            timezone = this.default_timezone;
        }
        return moment(value).tz(timezone).format(format);
    }

}